import { useState, useEffect, useRef } from "react";
import {
  Autocomplete,
  Grid,
  TextField,
  FormControl,
  DatePicker,
  Divider,
} from "../../../../components";
import {
  SessionService,
  UsuarioService,
} from "../../../../services";
import { value } from "../../../../helpers";
import { responseErros, timeoutBuscaAutocomplete } from "../../../../utils";
import { useFiltrosRelatoriosHandlers } from "../../components/use-filtros-relatorios-handlers";

const usuarioService = new UsuarioService();
const sessionService = new SessionService();

const FormFiltroAvancadoItensCancelados = ({
  filtrosAvancados,
  setFiltrosAvancados,
  filtrosAplicadosImpressao,
  setFiltrosAplicadosImpressao,
  setValidationError
}) => {
  const inputRef = useRef();
  const [usuariosList, setUsuariosList] = useState([]);
  // const [condicaoPagamentoList, setCondicaoPagamentoList] = useState([]);
  // const [meioPagamentoList, setMeioPagamentoList] = useState([]);
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);
  const usuario = sessionService.getUsuario();
  const empresa = sessionService.getEmpresa();
  const { onChangeAutocomplete, onChangeDate } =
    useFiltrosRelatoriosHandlers(
      setFiltrosAvancados,
      setFiltrosAplicadosImpressao
    );

  useEffect(() => {
    setEstadoInicial();
  }, []);

  function setEstadoInicial() {
    const filtros = {
      ...filtrosAvancados,
      empresasIds: [empresa.id],
    };
    let filtrosImpressao = {};
    if (usuario.acessosEmpresas?.length) {
      filtrosImpressao = {
        ...filtrosAplicadosImpressao,
        ["Empresas-Associadas"]: empresa.razaoSocial,
      };
    }

    setFiltrosAvancados(filtros);
    setFiltrosAplicadosImpressao(filtrosImpressao);
  }

  const buscarOperadores = () => {
    const filtros = {
      nonPaginated: true,
    };
    usuarioService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setUsuariosList(result.data);
      } else {
        responseErros(result);
      }
    });
    setLoadingAutoComplete(false);
  };

  const onInputChangeOperador = (event) => {
    if (
      event.key === "Enter" &&
      inputRef?.current === document.activeElement
    ) {
      setLoadingAutoComplete(true);
      const filtros = {
        nome: event.target.value,
      };
      timeoutBuscaAutocomplete(buscarOperadores(filtros));
    }
  };

  function onChangeMultipleEmpresas(empresas) {
    setFiltrosAvancados((prevState) => ({
      ...prevState,
      empresasIds: empresas.map(({ id }) => id),
    }));
    setFiltrosAplicadosImpressao((prevState) => ({
      ...prevState,
      "Empresas-Associadas": empresas
        .map(({ razaoSocial }) => razaoSocial)
        .join(" | "),
    }));
  }

  return (
    <>
      {usuario.acessosEmpresas?.length > 0 && (
        <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Autocomplete
              multiple
              id="empresasIds"
              name="empresasIds"
              options={usuario.acessosEmpresas}
              noOptionsText="Sem opções"
              autoHighlight
              disablePortal
              filterSelectedOptions
              getOptionLabel={(option) => option?.razaoSocial || ""}
              onChange={(_, newValue) => onChangeMultipleEmpresas(newValue)}
              value={value.multiple(
                usuario.acessosEmpresas || [],
                filtrosAvancados["empresasIds"]
                  ? filtrosAvancados["empresasIds"]
                  : ""
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  required
                  label="Empresas"
                  margin="normal"
                />
              )}
            />
          </Grid>
        </Grid>
        <Divider sx={{ mt: 2, mb: 1, border: "1px solid grey" }}/>
        </>
      )}
      <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl variant="outlined" margin="normal" fullWidth>
              <Autocomplete
                id="usuario"
                name="Operador"
                options={usuariosList}
                autoHighlight
                disablePortal
                getOptionLabel={(option) => option?.nome ?? ""}
                getOptionSelected={(option, value) =>
                  option?.nome === value?.nome
                }
                loading={loadingAutoComplete}
                loadingText="Carregando"
                noOptionsText="Digite e pressione Enter"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Operador"
                    variant="outlined"
                    onKeyDown={(e) => onInputChangeOperador(e, 1)}
                    inputRef={inputRef}
                    InputProps={{
                      ...params.InputProps,
                    }}
                  />
                )}
                onChange={(e, value) =>
                  onChangeAutocomplete("userId", value, "Operador")
                }
                value={value.autoComplete(
                  usuariosList,
                  filtrosAvancados?.userId
                )}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <DatePicker
              id="createdAtStart"
              name="Data-Cancelamento-De"
              label="Data Cancelamento De"
              margin
              format="dd/MM/yyyy"
              value={value.date(filtrosAvancados?.createdAtStart)}
              onChange={(date) =>
                onChangeDate("createdAtStart", date, "Data-Inicial")
              }
              slotProps={{
                popper: { sx: { zIndex: 2000 }, }
              }}
              setError={setValidationError}
            />
          </Grid>
          <Grid item xs={6}>
            <DatePicker
              id="createdAtEnd"
              name="Data-Cancelamento-Até"
              label="Data Cancelamento Até"
              margin
              format="dd/MM/yyyy"
              value={value.date(filtrosAvancados?.createdAtEnd)}
              onChange={(date) =>
                onChangeDate("createdAtEnd", date, "Data-Final")
              }
              slotProps={{
                popper: { sx: { zIndex: 2000 }, }
              }}
              setError={setValidationError}
            />
          </Grid>
        </Grid>
        {/* <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControl variant="outlined" margin="normal" fullWidth>
              <Autocomplete
                id="condicaoPagamentoId"
                name="Condição-de-Pagamento"
                options={condicaoPagamentoList}
                autoHighlight
                disablePortal
                getOptionLabel={(option) =>
                  option.id && option.descricao
                    ? `${option.id} - ${option.descricao}`
                    : ""
                }
                getOptionSelected={(option, value) =>
                  option?.descricao === value?.descricao
                }
                noOptionsText="Sem opções"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Condição de Pagamento"
                    variant="outlined"
                  />
                )}
                onChange={(e, value) =>
                  onChangeAutocomplete(
                    "condicaoPagamentoId",
                    value,
                    "Condição-de-Pagamento"
                  )
                }
                value={value.autoComplete(
                  condicaoPagamentoList,
                  filtrosAvancados?.condicaoPagamentoId
                )}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl variant="outlined" margin="normal" fullWidth>
              <Autocomplete
                id="meioPagamentoId"
                name="Meio-de-Pagamento"
                options={meioPagamentoList}
                autoHighlight
                disablePortal
                getOptionLabel={(option) =>
                  option.id && option.descricao
                    ? `${option.id} - ${option.descricao}`
                    : ""
                }
                getOptionSelected={(option, value) =>
                  option?.descricao === value?.descricao
                }
                noOptionsText="Sem opções"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Meios de pagamento"
                    variant="outlined"
                  />
                )}
                onChange={(e, value) =>
                  onChangeAutocomplete(
                    "meioPagamentoId",
                    value,
                    "Meio-de-Pagamento"
                  )
                }
                value={value.autoComplete(
                  meioPagamentoList,
                  filtrosAvancados?.meioPagamentoId
                )}
              />
            </FormControl>
          </Grid>
        </Grid> */}
    </>
  );
};

export default FormFiltroAvancadoItensCancelados;
